/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CenterGroupControllerConnectUsers$Params {
  centerGroupId: string;
  centerUserIds: Array<string>;
}

export function centerGroupControllerConnectUsers(http: HttpClient, rootUrl: string, params: CenterGroupControllerConnectUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, centerGroupControllerConnectUsers.PATH, 'patch');
  if (params) {
    rb.query('centerGroupId', params.centerGroupId, {});
    rb.query('centerUserIds', params.centerUserIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

centerGroupControllerConnectUsers.PATH = '/api/center-group/connect-user';
